<template>
  <div v-if="display">
    <modal-layout-top :title="title"/>
    <div class="content slider-modal">

      <div class="tabs">
        <ul>
          <li :class="{ 'is-active': tab === 'overview'}"><a @click="tab='overview'">Översikt</a></li>
          <li :class="{ 'is-active': tab === 'contact'}"><a @click="tab='contact'">Kontaktuppgifter</a></li>
          <li :class="{ 'is-active': tab === 'server-info'}"><a @click="tab='server-info'">Server-info</a></li>
        </ul>
      </div>

      <div v-if="tab === 'overview'" class="slider-modal-fields">
        <div class="field">
          <label class="label">Namn</label>
          <input class="input" type="text" v-model="customer.name" />
        </div>

        <div class="field">
          <label class="label">Org. nr.</label>
          <input class="input" type="email" v-model="customer.organizationNumber" />
        </div>

        <div class="field">
          <input id="has-reseller" type="checkbox" v-model="hasReseller" class="switch is-rounded">
          <label for="has-reseller" class="label">Har återförsäljare</label>
        </div>

        <div class="field-full" v-if="hasReseller">
          <div class="is-flex">
            <template v-if="hasReseller">
              <div class="select is-inline-input">
                <select v-model="customer.resellerId">
                  <option :value="null">Välj återförsäljare...</option>
                  <option v-for="reseller in resellers" :key="reseller.resellerId" :value="reseller.resellerId">{{ reseller.name }}</option>
                </select>
              </div>
              <button @click="openResellerModal(customer.resellerId)" :disabled="!customer.resellerId" class="button is-inline-button is-info"><i class="fal fa-edit"></i></button>
              <button @click="openResellerModal()" class="button is-inline-button is-info"><i class="fal fa-plus"></i></button>
            </template>
          </div>
        </div>

        <div class="slider-subtitle">Kommentar</div>
        <div class="field-full">
          <textarea class="textarea" v-model="customer.comments" />
        </div>

        <div class="slider-subtitle">Server-info</div>
        <div class="field-full">
          <div class="mini-table-wrapper">
            <div class="key">OS</div>
            <div class="value">{{ customer.os || '-' }}</div>
          </div>
          <div class="mini-table-wrapper">
            <div class="key">CPU</div>
            <div class="value">{{ customer.cpu || '-' }}</div>
          </div>
          <div class="mini-table-wrapper">
            <div class="key">RAM</div>
            <div class="value">{{ ram }}</div>
          </div>
          <div class="mini-table-wrapper">
            <div class="key">GPU</div>
            <div class="value">{{ customer.gpu || '-' }}</div>
          </div>
        </div>

        <template v-if="customerId">
          <div class="slider-subtitle">Övrigt</div>
          <div class="field-full meta-data">Skapad av {{ customer.createdByFullName }} {{ customer.dateCreated | dateTime }}</div>
          <div class="field-full meta-data" v-if="customer.modifiedByUserId">Senast ändrad av {{ customer.modifiedByFullName }} {{ customer.dateModified | dateTime }}</div>
        </template>
      </div>

      <div v-if="tab === 'contact'" class="slider-modal-fields">
        <div class="slider-subtitle">Adress</div>

        <div class="field">
          <label class="label">Gatuadress</label>
          <input class="input" type="text" v-model="customer.streetAddress">
        </div>

        <div class="field">
          <label class="label">Postnummer</label>
          <input class="input" type="text" v-model="customer.zip">
        </div>

        <div class="field">
          <label class="label">Postort</label>
          <input class="input" type="text" v-model="customer.city">
        </div>

        <div class="field">
          <label class="label">Land</label>
          <div class="select">
            <select v-model="customer.countryId">
              <option :value="null">Välj land...</option>
              <option v-for="country in countries" :key="country.iso2" :value="country.countryId">{{ country.nameSwedish }}</option>
            </select>
          </div>
        </div>
        <div class="field-full">
          <hr>
        </div>

        <div class="field">
          <label class="label">Email</label>
          <div class="is-flex">
            <input class="input is-inline-input" type="text" v-model="customer.email">
            <a class="button is-inline-button is-info" :href="emailHref" :disabled="!emailHref"><i class="fal fa-envelope"></i></a>
          </div>
        </div>

        <div class="field">
          <label class="label">Telefon</label>
          <div class="is-flex">
            <input class="input is-inline-input" type="text" v-model="customer.phone">
            <a class="button is-inline-button is-info" :href="phoneHref" :disabled="!customer.phone"><i class="fal fa-phone"></i></a>
          </div>
        </div>
      </div>

      <modal-layout-buttons :store-name="'customers'" />

    </div>
  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'
import ResellerModal from '@/components/modals/ResellerModal'

export default {
  name: 'customer-modal',

  data () {
    return {
      customer: {
        name: ''
      },
      resellers: [],
      hasReseller: false,
      tab: 'overview',
      submitted: false,
      display: false
    }
  },

  components: {
    ModalLayoutTop,
    ModalLayoutButtons,
    ResellerModal
  },

  props: {
    customerId: {
      type: Number,
      required: false
    },

    resellerId: {
      type: Number,
      required: false
    }
  },

  computed: {
    ...mapState({
      customers: state => state.customers.all,
      countries: state => state.meta.all.countries
    }),

    emailHref () {
      if (this.customer.email) {
        return `mailto:${this.customer.email}`
      }

      return null
    },

    phoneHref () {
      if (this.customer.phone) {
        return `tel:${this.customer.phone}`
      }

      return null
    },

    ram () {
      if (this.customer.ram) {
        return `${this.customer.ram} GB`
      }

      return '-'
    },

    title: function () {
      if (!this.customerId) {
        return 'Lägg till ny kund'
      } else {
        return 'Redigera kund ' + this.customer.name
      }
    }
  },

  methods: {
    ...mapActions('customers', ['update', 'create', 'getById']),
    ...mapActions({
      getAllResellers: 'resellers/getAll'
    }),

    openResellerModal (resellerId) {
      this.$panel(ResellerModal, { resellerId }).then(data => {
        if (data.response) {
          if (resellerId) {
            // Existing reseller
            this.resellers = this.resellers.map(reseller =>
              reseller.resellerId === data.response.resellerId ? data.response : reseller
            )

            this.customer.resellerId = data.response.resellerId
          }
          else {
            // New reseller
            this.resellers.push(data.response)
            this.customer.resellerId = data.response.resellerId
          }
        }

        console.log(data)
      })
    },

    closePanel () {
      this.$emit('closePanel', { response: this.cust })
    },

    getFormattedAddress (address) {
      let parts = []

      if (address.streetAddress) {
        parts.push(address.streetAddress)
      }
      if (address.zip || address.city) {
        parts.push(address.zip + ' ' + address.city)
      }
      return parts.join(', ')
    },

    save () {
      this.submitted = true
      this.$validator.validateAll()

      if (this.customerId) {
        this.update(this.customer).then(response => {
          this.closePanel()
        })
      } else {
        this.create(this.customer).then(customer => {
          this.cust = customer
          this.closePanel()
        })
      }
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    let promises = []

    if (this.customerId) {
      promises.push(this.getById(this.customerId).then(customer => {
        this.customer = customer.result
        this.hasReseller = !!this.customer.resellerId
      }))
    }

    if (this.resellerId) {
      this.customer.resellerId = this.resellerId
      this.hasReseller = !!this.customer.resellerId
    }

    promises.push(this.getAllResellers().then(resellers => {
      this.resellers = resellers
    }))

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>

<style lang="scss" scoped>
  .is-inline-input {
    flex-grow: 1;
  }
  .is-inline-button {
    text-align: right;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/CustomerModal.vue